import React, { FC, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useMediaQuery } from 'react-responsive';

import Spacer from 'components/Spacer';
import SeedStarter from 'components/Logo/SeedStarter';

const SeedStarterLogo: FC = () => {
  const theme = useContext(ThemeContext);
  const isMobile = useMediaQuery({
    maxWidth: theme.breakpoints.large,
  });

  return isMobile ? (
    <>
      <Spacer height="massive" />
      <FlexLogo>
        <SeedStarter />
      </FlexLogo>
    </>
  ) : null;
};

const FlexLogo = styled.div`
  flex: 1;
  justify-content: center;
  display: flex;
  align-items: center;

  & > div {
    max-width: 200px;
  }
`;

export default SeedStarterLogo;
